/**
 * Fired on `window` in the app when the server ended the device session (a refresh answered 401, or no refresh token is left).
 * The auth context turns it into the sign-in screen through the router: the app never reloads the WebView, so the outbox keeps
 * running. The detail is `{ code, message }`.
 */
export const SESSION_EXPIRED_EVENT = 'session:expired';

export interface SessionExpired {
  /** `refresh_reused`, `access_ended`, `invalid_refresh_token`, or `no_refresh_token`. */
  code: string;
  message: string;
}

export const REFRESH_REUSED_MESSAGE = 'You were signed out on this phone. Sign in again.';
export const SESSION_ENDED_MESSAGE = 'Your session ended. Sign in again.';
/** A person the owner removed (or who deleted their own login): the server's `session_ended` reason `access_ended`. */
export const ACCESS_ENDED_MESSAGE = 'Your access to this business ended. Contact the owner.';
export const MOBILE_APP_DISABLED_MESSAGE = 'The mobile app is not enabled for this business.';
